<template>
	<div>
		<!-- <Multiselect v-model="data.value" :options="data.options" /> -->
		<Multiselect
			v-model="data.value"
			placeholder="Choose a country"
			:filter-results="false"
			:min-chars="3"
			:resolve-on-load="true"
			:delay="0"
			:searchable="true"
			:options="
				async function (query) {
					return await getCity(query); // check JS block in JSFiddle for implementation
				}
			"
		/>
	</div>
</template>

<script>
	//! working but not usable { for experimentation }
	import { reactive, inject, watch } from "vue";
	import masterStore from "@/store/masterStore";
	import Multiselect from "@vueform/multiselect";
	import toast from "@/config/toast";
	import API from "@/config/api";

	export default {
		components: {
			Multiselect,
		},

		setup: () => {
			const masterStore = inject("masterStore");

			const data = reactive({
				value: null,
				options: ["Batman", "Robin", "Joker"],
				cities: null,
			});

			const getCity = async (name) => {
				try {
					const response = await API.privateRequest.get(`/cities?name=${name}`);
					data.cities = response.data.data;
					const cities = response.data.data.map((city) => {
						return { label: city.name, value: city._id };
					});
					return cities;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			watch(
				() => data.value,
				(newValue, prevValue) => {
					if (!newValue) return;
					const selected = data.cities.filter((city) => city._id === newValue);
					const {
						_id,
						id,
						name,
						state_id,
						state_name,
						country_id,
						country_name,
					} = selected[0];
					masterStore.methods.setGeo("city", {
						mongoId: _id,
						id,
						name,
						stateId: state_id,
					});
					masterStore.methods.setGeo("country", {
						id: country_id,
						name: country_name,
					});
					masterStore.methods.setGeo("state", {
						id: state_id,
						name: state_name,
					});
				},
			);

			return {
				getCity,
				data,
			};
		},
	};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
